module.exports = __webpack_public_path__ + "img/insta-1.98f89c2a.jpg";